export enum IframeEventKeys {
    VERIFY_TOKEN = 'VERIFY-TOKEN',
    LOGIN_SUCCESS = 'login-success',
    ALERT_WARN = 'alert-warn',
    NAVIGATE = 'iframe-call-navigate',
    CALLBACK_NO_TOKEN = 'CALLBACK-NO-TOKEN',
    LOGIN_FAIL = 'login-fail',
}

export enum IframeNavigatePath {
    FORGOT_PASSWORD = 'forgot-password',
    FORGOT_PASSWORD_SETTING = 'forgot-password-setting/:token',
    SETTING_PASSWORD = 'setting-password/:token',
    REGISTER = 'register',
    VERIFY = 'verify/:token',
    LOGIN = 'login',
    LOGOUT = 'logout',
}
